import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ForecastForm from "./ForecastForm";

const today = () => new Date().toISOString().slice(0, 10);

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({ start_date: today(), end_date: today() });
  const [rows, setRows] = useState([]);
  const [segmentDates, setSegmentDates] = useState([{ start_date: "", end_date: "" }]);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await Http.get("/demand-forecast-products");
        setRows(
          res.data.map((product) => ({
            ...product,
            weight: "",
            length: "",
            height: "",
            width: "",
            segments: [0],
          }))
        );
      } catch (e) {
        console.error("Fetch error:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleRowChange = (rowIndex, field, value) => {
    setRows((prev) => prev.map((row, i) => (i === rowIndex ? { ...row, [field]: value } : row)));
  };

  const handleSegmentQtyChange = (rowIndex, segIndex, value) => {
    setRows((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;
        const segments = [...row.segments];
        segments[segIndex] = value;
        return { ...row, segments };
      })
    );
  };

  const handleSegmentDateChange = (index, field, value) => {
    setSegmentDates((prev) => prev.map((segment, i) => (i === index ? { ...segment, [field]: value } : segment)));
  };

  // A segment column exists in two places: the date header and one cell per row.
  const addSegment = () => {
    setSegmentDates((prev) => [...prev, { start_date: "", end_date: "" }]);
    setRows((prev) => prev.map((row) => ({ ...row, segments: [...row.segments, 0] })));
  };

  const removeSegment = (index) => {
    if (segmentDates.length < 2) {
      Swal.fire("Warning!", "At least one segment column is required.", "warning");
      return;
    }
    setSegmentDates((prev) => prev.filter((_, i) => i !== index));
    setRows((prev) => prev.map((row) => ({ ...row, segments: row.segments.filter((_, i) => i !== index) })));
  };

  const formSubmit = () => {
    const filled = rows.filter((row) => row.segments.some((qty) => Number(qty) > 0));

    if (filled.length < 1) {
      Swal.fire("Warning!", "Please fill in at least one product segment.", "warning");
      return;
    }

    Http.post("/demand-forecast", { ...inputs, segment_dates: segmentDates, rows: filled })
      .then((res) => {
        navigate("/demand-forecast", { state: { message: res.data.message, type: "success" } });
      })
      .catch((e) => {
        setError(e.response?.data?.errors || {});
        if (e.response?.data?.message && !e.response?.data?.errors) {
          Swal.fire("Failed!", e.response.data.message, "error");
        }
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <ForecastForm
        title="Create Demand Forecast"
        submitLabel="Save Demand Forecast"
        inputs={inputs}
        rows={rows}
        segmentDates={segmentDates}
        loading={loading}
        error={error}
        onInputChange={handleInputChange}
        onRowChange={handleRowChange}
        onSegmentQtyChange={handleSegmentQtyChange}
        onSegmentDateChange={handleSegmentDateChange}
        onAddSegment={addSegment}
        onRemoveSegment={removeSegment}
        onSubmit={formSubmit}
      />
    </div>
  );
};

export default Create;
